// 响应式工具函数

/**
 * 检测设备类型
 * @returns {string} 'mobile' | 'tablet' | 'primary' | 'desktop'
 */
export function getDeviceType() {
  const width = window.innerWidth || document.documentElement.clientWidth
  
  if (width <= 767) {
    return 'mobile'
  } else if (width >= 768 && width <= 1024) {
    return 'tablet'
  } else if (width >= 1080) {
    return 'primary'
  } else {
    return 'desktop'
  }
}

/**
 * 是否为移动设备
 * @returns {boolean}
 */
export function isMobile() {
  return getDeviceType() === 'mobile'
}

/**
 * 是否为主设备（1080px）
 * @returns {boolean}
 */
export function isPrimaryDevice() {
  return getDeviceType() === 'primary'
}

/**
 * 获取响应式字体大小
 * @param {number} primarySize - 主设备字体大小
 * @param {number} mobileSize - 手机设备字体大小（可选）
 * @returns {number}
 */
export function getResponsiveFontSize(primarySize, mobileSize = null) {
  if (isMobile()) {
    return mobileSize || primarySize * 0.5
  }
  return primarySize
}

/**
 * 获取响应式间距
 * @param {number} primarySpacing - 主设备间距
 * @param {number} mobileSpacing - 手机设备间距（可选）
 * @returns {number}
 */
export function getResponsiveSpacing(primarySpacing, mobileSpacing = null) {
  if (isMobile()) {
    return mobileSpacing || primarySpacing * 0.5
  }
  return primarySpacing
}

/**
 * 监听窗口大小变化
 * @param {Function} callback - 回调函数
 * @returns {Function} 取消监听的函数
 */
export function onResize(callback) {
  let ticking = false
  
  const handler = () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        callback()
        ticking = false
      })
      ticking = true
    }
  }
  
  window.addEventListener('resize', handler)
  
  return () => {
    window.removeEventListener('resize', handler)
  }
}

/**
 * 获取视口宽度
 * @returns {number}
 */
export function getViewportWidth() {
  return window.innerWidth || document.documentElement.clientWidth
}

/**
 * 获取视口高度
 * @returns {number}
 */
export function getViewportHeight() {
  return window.innerHeight || document.documentElement.clientHeight
}

